module.exports = __webpack_public_path__ + "static/media/Games Consols.afd8ed59.svg";